import { motion } from "framer-motion";
import { Star } from "lucide-react";
import { reveal, revealContainer, viewportOnce } from "../../lib/motion";

const REVIEWS = [
  {
    quote:
      "The food was beautifully presented and absolutely delicious. Perfect for our office meeting.",
    author: "Corporate Client, Auckland CBD",
  },
  {
    quote: "Excellent service and authentic Japanese flavours.",
    author: "Private Event Host",
  },
  {
    quote: "Our guests loved every dish. Highly recommended.",
    author: "Birthday Celebration, Mount Eden",
  },
];

export const Testimonials = () => (
  <section data-testid="testimonials-section" className="bg-sage/15 py-24 md:py-32">
    <div className="mx-auto max-w-[1400px] px-6 md:px-10">
      <div className="max-w-2xl mb-16">
        <span className="label-caps text-sage">Testimonials</span>
        <h2 className="mt-4 font-serif text-4xl md:text-5xl text-ink">
          Loved by Auckland
        </h2>
      </div>
      <motion.div
        variants={revealContainer}
        initial="hidden"
        whileInView="show"
        viewport={viewportOnce}
        className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8"
      >
        {REVIEWS.map((r, i) => (
          <motion.blockquote
            key={i}
            variants={reveal}
            data-testid={`testimonial-${i}`}
            className="bg-cream border border-border p-8 md:p-10 flex flex-col gap-6"
          >
            <div className="flex gap-1 text-gold">
              {Array.from({ length: 5 }).map((_, s) => (
                <Star key={s} size={18} fill="currentColor" strokeWidth={0} aria-hidden="true" />
              ))}
            </div>
            <p className="font-serif text-2xl md:text-[1.7rem] leading-snug text-ink italic">
              &ldquo;{r.quote}&rdquo;
            </p>
            <cite className="label-caps text-ink/50 not-italic mt-auto">{r.author}</cite>
          </motion.blockquote>
        ))}
      </motion.div>
    </div>
  </section>
);
